import React from 'react';
import ReloadButton from '../../../../features/ReloadButton/ReloadButton';
import { InputFieldSearch, SelectOption, addOption } from '../../../../utils/InputField';

function PageHeaderLeftCol({ filterHandler, p }) {
    return (
        <form className="subscriptions_page_header_left_col flex-1 flex items-center gap-x-3">
            <InputFieldSearch
                label="Search by service name or product name"
                name="q"
                formData={p}
                onChange={filterHandler}
                className="rounded-10 w-68"
            />
            <SelectOption
                placeholder="Status"
                name="status"
                formData={p}
                onChange={filterHandler}
                options={['Initiate', 'Implement', 'Ongoing', 'Completed'].map((d) =>
                    addOption(d, d, d.toLowerCase())
                )}
                className="rounded-10 w-36"
            />
        </form>
    );
}

function ServiceManagePageHeader({ p, filterHandler, handleReload }) {
    return (
        <div className="subscription_page_header mb-7 flex flex-row justify-between items-center">
            <PageHeaderLeftCol p={p} filterHandler={filterHandler} />
            <ReloadButton height="h-10" width="w-10" onClick={handleReload} />
        </div>
    );
}

export default ServiceManagePageHeader;
